import React, { useEffect, useState } from "react";
import { Column, Row, Sheet, Text, Icon } from "@amzn/meridian";
import checkCircleTokens from "@amzn/meridian-tokens/base/icon/check-circle"

interface StepTransitionSheetProps {
    headerMessage: string
    message: string;
    onClose: () => void;
}

const StepTransitionSheet: React.FC<StepTransitionSheetProps> = ({
    headerMessage = "Step complete",
    message = "Moving to next step...",
    onClose,
}) => {
    const [open, setOpen] = useState(false);

    // Constants for timing control
    const SHEET_DISPLAY_DURATION_MS = 2500;
    const SHEET_CLOSE_ANIMATION_MS = 500;
    const CALLBACK_DELAY_MS = 500;

    useEffect(() => {
        // Open sheet immediately
        setOpen(true);

        // Schedule sheet close and callback
        const closeTimer = setTimeout(() => {
            setOpen(false);
        }, SHEET_DISPLAY_DURATION_MS);

        // Call onClose after sheet animation completes
        const callbackTimer = setTimeout(() => {
            onClose();
        }, SHEET_DISPLAY_DURATION_MS + CALLBACK_DELAY_MS);

        return () => {
            clearTimeout(closeTimer);
            clearTimeout(callbackTimer);
        };
    }, []);

    return (
        <Sheet
            type="overlay"
            side="bottom"
            open={open}
            onClose={() => {
                // This is called if user manually closes the sheet by touching outside it.
                setOpen(false);
                onClose();
            }}
            motionDuration={SHEET_CLOSE_ANIMATION_MS}
        >
            <Column spacing="400">
                <Row alignmentHorizontal="center">
                    <Column spacing="200" alignmentHorizontal="center">
                        <Icon tokens={checkCircleTokens} color="success" />
                        <Text type="h400">{headerMessage}</Text>
                        <Text type="b100" color="secondary">
                            {message}
                        </Text>
                    </Column>
                </Row>
            </Column>
        </Sheet>
    );
};

export default StepTransitionSheet;
